import LocalizedStrings from "react-localization";
import headerStrings from "./HeaderStrings.js";
import footerStrings from "./FooterStrings.js";
import homePageStrings from "./HomePageStrings.js";
import loginStrings from "./LoginStrings.js";

let webContentStrings = new LocalizedStrings({
    en: {
        headerStrings: headerStrings,
        footerStrings: footerStrings,
        homePageStrings: homePageStrings,
        loginStrings: loginStrings,

    },
});

export default webContentStrings;